import ProfileRoute from './routes/Profile.vue'
import SettingsRoute from './routes/Settings.vue'
import * as ClientAdminRoutes from '@/contexts/client-admin/routes'
import * as ConversationsRoutes from '@/contexts/conversations/routes'

function title(subtitle: string) {
  const suffix = subtitle ? ` - ${subtitle}` : ''
  return `KAI Conversations${suffix}`
}

export const routes = [
  ...ConversationsRoutes.RouteConfig,
  {
    path: '/profile',
    name: 'profile',
    component: ProfileRoute,
    meta: {
      title: title('Profile')
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsRoute,
    meta: {
      title: title('Settings')
    },
    children: [...ClientAdminRoutes.RouteConfig]
  }
]

export default routes
